// 通知空值狀態
import Image from 'next/image';

const EmptyNotification = ({ t }) => {
    return (
        <div className="w-full flex flex-col items-center text-center text-purple pt-[22px] border-t-1 border-dashed border-black2">
            <Image width={98} height={91} src="/images/icon/icon_empty_notify.svg" alt="icon" />
            <p className="text-h6 mt-[22px] mb-[14px]">{t('EMPTY_NOTIFY')}</p>
            <p className="text-bd4n">{t('EMPTY_NOTIFY_CONTENT')}</p>
        </div>
    );
};

export default EmptyNotification;
